import { withFormik } from "formik";
import * as Yup from "yup";

const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    name: Yup.string().required("Please Enter Name"),
    email: Yup.string()
      .email("Please enter valid email")
      .required("Please Enter Email"),
    phone: Yup.string()
      .matches(/^\d+$/, "Please Enter valid Phone Number")
      .length(10, "Please Enter valid phone number")
      .required("Please Enter Phone Number"),
    address1: Yup.string().required("Please enter address line 1"),
    address2: Yup.string(),
    city: Yup.string()
      .matches(/^[A-Z a-z]+$/, "Please enter valid city")
      .required("Please enter city"),
    state: Yup.string(/^[A-Z a-z]+$/, "Please enter valid state").required(
      "Please enter state"
    ),
    pincode: Yup.string()
      .matches(/^[0-9]+$/, "Please enter valid pincode")
      .typeError("Please enter valid pin")
      .min(4)
      .max(10)
      .required("Please enter pincode")
  }),
  mapPropsToValues: props => ({
    name: "",
    email: "",
    phone: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    pincode: ""
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
